import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import http from './utils/http';
import './index.scss';
Vue.use(Antd);
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
 
Vue.use(ElementUI);
// plugins
import './plugins/vue-layer';

// 面包屑
import BreadCrumb from './components/BreadCrumb/index';
import TableSearch from './components/TableSearch/index';
import PopconfirmButton from './components/PopconfirmButton/index';
import BasicForm from './components/form/index';
import FormButton from './components/FormButton/index';
import FormCard from './components/FormCard/index';
import EditableCell from './components/EditableCell/index';


Vue.component('bread-crumb', BreadCrumb);
Vue.component('table-search', TableSearch);
Vue.component('popconfirm-button', PopconfirmButton);
Vue.component('basic-form', BasicForm);
Vue.component('form-button', FormButton);
Vue.component('form-card', FormCard);
Vue.component('editable-cell', EditableCell);

// 自定义图标
import { Icon } from 'ant-design-vue';
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1595715_dnlaxrfu7mc.js',
});
Vue.component('icon-font', IconFont);

Vue.config.productionTip = false;
Vue.prototype.$http = http;

// 全局设置默认语言
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
// 时间戳转monment
Vue.prototype.$Moment = (time) => moment.unix(time);
// 时间戳显示时间
Vue.prototype.$Format = (time) => moment.unix(time).format('YYYY-MM-DD HH:mm:ss');
// moment转日期
Vue.prototype.$Date = (time) => time.format('YYYY-MM-DD');
// moment转时间戳
Vue.prototype.$Times = (time) => moment(time).unix();

// 上传域名设置
Vue.prototype.uploadUrl = process.env.NODE_ENV === 'development' ? 'http://xyf.local.com/v1/' : '/v1/';
// Vue.prototype.uploadUrl = process.env.NODE_ENV === 'development' ? 'https://admin-saas.cigomsg.com/v1/' : '/v1/';

const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
export default vue;
